module.exports = __webpack_public_path__ + "img/gold.58806b76.png";